<template>
  <v-list-item three-line dense
               class="lighten-4 grey"
               active-class="primary"
               :disabled="lesson.freeRecords===0 || hasRecord || !canRecord || isRecordFrozen"
               :value="lesson.id">
    <v-list-item-content>
      <v-list-item-title>{{ lesson.beginTime}}-{{lesson.endTime}}</v-list-item-title>
      <v-list-item-subtitle>{{ roomName }} - {{ teachers }}</v-list-item-subtitle>
      <v-list-item-subtitle>{{ lesson.topic }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="pt-3">
      <v-list-item-action-text v-if="hasRecord">
        Записан
      </v-list-item-action-text>
      <v-list-item-action-text v-if="!hasRecord && lesson.freeRecords>0">
        Еще {{ lesson.freeRecords }} мест
      </v-list-item-action-text>
      <v-list-item-action-text v-if="!hasRecord && lesson.freeRecords===null && classFreeRecords">
        Еще {{ classFreeRecords }} мест
      </v-list-item-action-text>
      <v-list-item-action-text v-if="!hasRecord && lesson.freeRecords===0">
        Мест нет
      </v-list-item-action-text>
      <v-list-item-action-text v-if="isRecordFrozen && !hasRecord">
        Абонемент заморожен
      </v-list-item-action-text>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
import { getClassColor, checkAllowRecord, checkIfFrozen } from '../../lib/classHelpers';

export default {
  name: 'LessonListItem',
  props: ['lesson'],
  computed: {
    roomName() {
      const room = this.rooms.find(r => r.id === this.lesson.roomId);
      return room ? room.name : null;
    },
    teachers() {
      return this.managers
        .filter(m => this.lesson.teacherIds && this.lesson.teacherIds.includes(m.id))
        .map(m => m.name).join(', ');
    },
    hasRecord() {
      return this.lesson.records && this.lesson.records.length > 0;
    },
    canRecord() {
      return checkAllowRecord(this.lesson, this.currentUser);
    },
    isRecordFrozen() {
      return checkIfFrozen(this.lesson, this.currentUser);
    },
    classFreeRecords() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      return cl ? cl.freeRecords : null;
    },
    color() {
      return getClassColor(this.lesson.classId);
    },
    ...mapGetters(['rooms', 'classes', 'managers', 'currentUser']),
  },
};
</script>

<style scoped>

</style>
